import { FavouriteConversationsState } from './_types';

export const initialState: FavouriteConversationsState = {
    favouriteConversations: null,
};
